export enum OutgoingMessageChannel {
    Sms = 'sms',
    Email = 'email',
    Whatsapp = 'whatsapp'
}

export enum OutgoingMessageStatus {
    Pending = 'pending',
    Sent = 'sent',
    Error = 'error'
}

export enum OutgoingMessageFeature {
    ClientConnectNotification = 'client-connect-notification',
    ClientSessionInvite = 'client-session-invite',
}

export enum OutgoingMessageStatusDetails {
    Unexpected = 'unexpected',
    ThrottlingExceeded = 'throttling_exceeded',
    RecipientInvalidPhoneNumber = 'recipient_invalid_phone_number',
    InvalidSender = 'invalid_sender',
    MaxLengthExceeded = 'max_length_exceeded',
    RegionRestriction = 'region_restriction',
    MissingLink = 'missing_link',
}

export type OutgoingMessage = {
    id: string;
    createdAt: Date;
    createdBy: number;
    channel: OutgoingMessageChannel;
    content: string;
    subject?: string;
    recipient?: string;
    status: OutgoingMessageStatus;
    feature: OutgoingMessageFeature;
    statusDetails?: OutgoingMessageStatusDetails;
}